// Each language is named in itself, so a user who can't read the current UI language still finds theirs.
export const OFFERED_LANGUAGES = [
    { tag: "en", name: "English" },
    { tag: "de", name: "Deutsch" },
];
const offered = OFFERED_LANGUAGES.map((language) => language.tag);
function isOffered(tag) {
    return offered.includes(tag);
}
export function baseLanguage(tag) {
    return tag.split("-")[0];
}
/** The offered language for a tag: the full tag if offered, else its base language, else none. */
export function matchLanguage(value) {
    if (!value)
        return undefined;
    let canonical;
    try {
        [canonical] = Intl.getCanonicalLocales(value.trim());
    }
    catch {
        return undefined;
    }
    if (!canonical)
        return undefined;
    if (isOffered(canonical))
        return canonical;
    const base = baseLanguage(canonical);
    return isOffered(base) ? base : undefined;
}
/** `de-AT` → `["de-AT", "de", "en"]`: the languages a text is looked up in, in order. */
export function fallbackChain(tag) {
    const chain = [tag];
    const base = baseLanguage(tag);
    if (base !== tag)
        chain.push(base);
    if (!chain.includes("en"))
        chain.push("en");
    return chain;
}
//# sourceMappingURL=languages.js.map